import { Grid } from '@mui/material';

import { InfoField, Link } from '@occc/ui-design-system';
import { MarketingContentFragment } from '@occc/graphql';
import { BREAK_URLS_STYLE } from '@occc-app/routes/CampaignComponents/component-details/sections/constants';

interface IMarketingContentDataProps {
  marketingContent: MarketingContentFragment;
}

export const MarketingContentData = ({ marketingContent }: IMarketingContentDataProps) => {
  const {
    termsUrl,
    terms,
    disclaimerUrl,
    disclaimer,
    title,
    shortDescription,
    longDescription,
    imageUrl,
  } = marketingContent || {};

  return (
    <Grid container spacing={2}>
      <Grid item sm={6}>
        <InfoField label='Title' value={title} />
      </Grid>
      <Grid item sm={6}>
        <InfoField
          label='Offer Image URL'
          value={
            imageUrl ? (
              <Link href={imageUrl} target='_blank' rel='noopener noreferrer' sx={BREAK_URLS_STYLE}>
                {imageUrl}
              </Link>
            ) : undefined
          }
          disableTypography={!!imageUrl}
        />
      </Grid>
      <Grid item sm={6}>
        <InfoField label='Short Description' value={shortDescription} />
      </Grid>
      <Grid item sm={6}>
        <InfoField label='Long Description' value={longDescription} />
      </Grid>
      <Grid item sm={6}>
        <InfoField
          label='Terms and Conditions URL'
          value={
            termsUrl ? (
              <Link href={termsUrl} target='_blank' rel='noopener noreferrer' sx={BREAK_URLS_STYLE}>
                {termsUrl}
              </Link>
            ) : undefined
          }
          disableTypography={!!termsUrl}
        />
        <InfoField label='Terms' value={terms} />
      </Grid>
      <Grid item sm={6}>
        <InfoField
          label='Disclaimer URL'
          value={
            disclaimerUrl ? (
              <Link
                href={disclaimerUrl}
                target='_blank'
                rel='noopener noreferrer'
                sx={BREAK_URLS_STYLE}
              >
                {disclaimerUrl}
              </Link>
            ) : undefined
          }
          disableTypography={!!disclaimerUrl}
        />
        <InfoField label='Disclaimer' value={disclaimer} />
      </Grid>
    </Grid>
  );
};
